module.exports = __webpack_public_path__ + "static/img/online_doxxing.ee1ca028.png";